import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class RoomStatusHistoryApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/room-status-histories`;
    }

    createRoomStatusHistory(roomStatusHistory: any): Observable<any> {
        return this.httpClient.post<any>(this.url, roomStatusHistory);
    }

    updateRoomStatusHistory(roomStatusHistory: any): Observable<any> {
        return this.httpClient.put<any>(this.url, roomStatusHistory);
    }
}
